<div [formGroup]="form">
  <!-- Texto de apoio da seção (§8), no padrão da barra dos itens. -->
  <p class="vpg-apoio">
    <mat-icon class="material-symbols-outlined">info</mat-icon>
    <span>{{ apoio }}</span>
  </p>

  <!-- Condições comerciais em texto livre (decisão D7; Pedro, 24/09: nos DOIS documentos e antes dos
       recebimentos): o que o documento imprime além das parcelas — prazo, forma combinada, validade
       da condição. Opcional. -->
  <mat-form-field appearance="outline" class="w-100 vpg-condicoes">
    <mat-label>Condições comerciais</mat-label>
    <textarea matInput formControlName="condicoesComerciais" rows="3"
      [readonly]="isSomenteLeitura" placeholder="Ex.: Entrada de 30% na aprovação e o restante em 2 parcelas mensais."></textarea>
    <mat-hint>Texto livre impresso no documento, além dos recebimentos abaixo.</mat-hint>
  </mat-form-field>

  <!-- Recebimentos (§8.0): subseção com o Adicionar no cabeçalho.
       O tooltip vai no `span` porque botão desabilitado não recebe eventos de mouse. -->
  <div class="sub-section-container">
    <div class="sub-section-title">
      <mat-icon class="material-symbols-outlined">payments</mat-icon>
      <span>Recebimentos</span>
      @if (!isSomenteLeitura) {
        <div class="section-title-actions ms-auto">
          <span [matTooltip]="tooltipAdicionar" matTooltipPosition="left">
            <button mat-button type="button" class="btn-section" [disabled]="totalCoberto" (click)="adicionar()">
              <mat-icon class="material-symbols-outlined">add</mat-icon>
              Adicionar
            </button>
          </span>
        </div>
      }
    </div>

    <!-- Linha de acompanhamento + barra (§8.0): âmbar enquanto falta, verde ao fechar, vermelho ao exceder. -->
    <div class="vpg-acompanhamento" [class.vpg-falta]="cobertura === 'falta'" [class.vpg-fecha]="cobertura === 'fecha'"
      [class.vpg-excede]="cobertura === 'excede'">
      <div class="vpg-indicadores">
        <div class="vpg-indicador">
          <span class="vpg-rotulo">{{ rotuloTotal }}</span>
          <span class="vpg-valor">{{ totalDoDocumento | abnt: 'preco' : 2 }}</span>
        </div>
        <div class="vpg-indicador">
          <span class="vpg-rotulo">Lançado</span>
          <span class="vpg-valor">{{ lancado | abnt: 'preco' : 2 }}</span>
        </div>
        <div class="vpg-indicador vpg-indicador-diferenca">
          <span class="vpg-rotulo">{{ rotuloDiferenca }}</span>
          <span class="vpg-valor">
            {{ valorDiferenca | abnt: 'preco' : 2 }}
            @if (cobertura === 'fecha') {
              <mat-icon class="material-symbols-outlined vpg-ok">check_circle</mat-icon>
            }
          </span>
        </div>
      </div>
      <div class="vpg-barra">
        <div class="vpg-barra-preenchimento" [style.width.%]="percentualCoberto"></div>
      </div>
    </div>

    <!-- A lista. Excluir o último a deixa VAZIA de fato (§8.0) — o estado ilustrado é a resposta. -->
    @if (!recebimentos.length) {
      <app-empty-state icon="payments" title="Nenhum recebimento lançado"
        [subtitle]="isSomenteLeitura ? '' : 'Clique em Adicionar para lançar o primeiro recebimento.'">
      </app-empty-state>
    } @else {
      <div class="vpg-lista">
        @for (recebimento of recebimentos; track recebimento; let i = $index) {
          <app-vd-recebimento
            [recebimento]="recebimento"
            [indice]="i"
            [total]="recebimentos.length"
            [financas]="financas"
            [isCondicaoPagamentoLivre]="isCondicaoPagamentoLivre"
            [ehOrcamento]="ehOrcamento"
            [dataEmissao]="dataEmissao"
            [isSomenteLeitura]="isSomenteLeitura"
            [isNsuObrigatorio]="isNsuObrigatorio"
            [isObservacaoParcelaObrigatoria]="isObservacaoParcelaObrigatoria"
            [mascaraDinheiro]="mascaraDinheiro"
            [mascaraInteira]="mascaraInteira"
            (excluir)="remover(i)">
          </app-vd-recebimento>
        }
      </div>
    }
  </div>

  <!-- Centro de custo e rateio (§8.10) — também no orçamento (decisão D14). -->
  <div class="sub-section-container">
    <div class="sub-section-title">
      <mat-icon class="material-symbols-outlined">account_tree</mat-icon>
      <span>Centro de custo</span>
    </div>

    <app-vd-centro-custo
      [form]="form"
      [totalDoDocumento]="totalDoDocumento"
      [centrosCusto]="centrosCusto"
      [rateiosConfigurados]="rateiosConfigurados"
      [isSomenteLeitura]="isSomenteLeitura"
      [mascaraDinheiro]="mascaraDinheiro"
      [mascaraPercentual]="mascaraPercentual">
    </app-vd-centro-custo>
  </div>
</div>
